import { IBaseRespone } from "../../../model/respone/IBaseRespone"
import { hinhThucGiangApi } from "../../../api/category/hinhThucGiangApi"
import { rootActions } from "../../actions/rootActions"
import { eHinhThucGiangActionIds, IHinhThucGiangActionTypes } from "../../action-types/category/IHinhThucGiangActions"
import { call, put, takeEvery } from "redux-saga/effects"

const mainAction = rootActions.category.hinhThucGiang;

export function* hinhThucGiangSaga(): any {
    yield takeEvery(eHinhThucGiangActionIds.LOAD_START, loadWorker)
}

function* loadWorker(action: IHinhThucGiangActionTypes  ): any {
    const res: IBaseRespone = yield call(hinhThucGiangApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}